import { useTranslation } from 'react-i18next'
import {
  formatDate as _formatDate,
  formatDateFull as _formatDateFull,
  formatToday as _formatToday
} from '../utils/dateUtils'

/** Returns the t(key, params) translation function */
export function useT() {
  const { t } = useTranslation()
  return t
}

/** Returns current lang code ('it' | 'en') */
export function useLang() {
  const { i18n } = useTranslation()
  return i18n.language
}

/** Returns locale-aware date formatting helpers */
export function useDateFormat() {
  const { i18n } = useTranslation()
  const locale = i18n.language === 'it' ? 'it-IT' : 'en-GB'
  return {
    locale,
    formatDate:     (ds) => _formatDate(ds, locale),
    formatDateFull: (ds) => _formatDateFull(ds, locale),
    formatToday:    ()   => _formatToday(locale),
  }
}
